// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".label[data-v-3f0e6ab0] {\n  font-weight: normal;\n  font-size: 0.875rem;\n  color: #727272;\n}\n.info[data-v-3f0e6ab0] {\n  font-weight: normal;\n  color: #11291B;\n}\n@media only screen and (max-width: 768px) {\n.actions-dropdown[data-v-3f0e6ab0] .dropdown-toggle {\n    width: 100%;\n    font-size: 0.875rem;\n}\n}", ""]);
// Exports
module.exports = exports;
